import React, { useMemo } from 'react';
import { bytesToSI } from '@avalenti89/typescript-utils';


export const DetailsSize = ({ size }: { size?: number; }) => {
	const _size = useMemo(() => {
		return size ? bytesToSI(size ?? '') : undefined;
	}, [size]);

	if (!_size) return null;
	return <span className="details__size">({_size})</span>;
};
